// Auto-generated by backend/generate_wellness.py — diet & exercise tips for pilgrims (11 languages).
export const DIET_TIPS = [
  {
    "id": "sarapan",
    "icon": "Wheat",
    "tag": "",
    "title": {
      "id": "Sarapan bergizi sebelum beraktivitas",
      "en": "Eat a nutritious breakfast before activities",
      "ar": "تناوَل فطوراً مغذياً قبل البدء في الأنشطة",
      "fr": "Prenez un petit-déjeuner nutritif avant les activités",
      "de": "Essen Sie ein nahrhaftes Frühstück vor den Aktivitäten",
      "es": "Desayune de forma nutritiva antes de las actividades",
      "ru": "Ешьте питательный завтрак перед началом активности",
      "zh": "活动前吃一顿营养丰富的早餐",
      "ja": "活動前に栄養のある朝食をとりましょう",
      "ko": "활동 전에 영양가 있는 아침 식사를 하세요",
      "hi": "गतिविधियों से पहले पौष्टिक नाश्ता करें"
    },
    "body": {
      "id": "Mulai hari dengan karbohidrat kompleks (roti gandum, oat, nasi merah), protein (telur, yoghurt, kacang) dan buah. Sarapan menjaga energi untuk tawaf, sa'i, dan perjalanan panjang.",
      "en": "Start the day with complex carbohydrates (whole-grain bread, oats, brown rice), protein (eggs, yoghurt, nuts) and fruit. Breakfast keeps your energy up for Tawaf, Sa'i, and long journeys.",
      "ar": "ابدأ يومك بالكربوهيدرات المعقدة (خبز الحبوب الكاملة، الشوفان، الأرز البني) والبروتينات (البيض، الزبادي، المكسرات) والفاكهة. الفطور يحافظ على طاقتك أثناء الطواف والسعي والرحلات الطويلة.",
      "fr": "Commencez la journée avec des glucides complexes (pain complet, flocons d'avoine, riz brun), des protéines (œufs, yaourt, noix) et des fruits. Le petit-déjeuner maintient votre énergie pour le Tawaf, le Sa'i et les longs trajets.",
      "de": "Beginnen Sie den Tag mit komplexen Kohlenhydraten (Vollkornbrot, Haferflocken, brauner Reis), Proteinen (Eier, Joghurt, Nüsse) und Obst. Das Frühstück hält Ihre Energie für Tawaf, Sa'i und lange Wege aufrecht.",
      "es": "Comience el día con carbohidratos complejos (pan integral, avena, arroz integral), proteínas (huevos, yogur, frutos secos) y fruta. El desayuno mantiene su energía para el Tawaf, el Sa'i y los largos recorridos.",
      "ru": "Начинайте день со сложных углеводов (цельнозерновой хлеб, овсянка, бурый рис), белков (яйца, йогурт, орехи) и фруктов. Завтрак поддерживает энергию для Тавафа, Са'и и долгих переходов.",
      "zh": "用复合碳水化合物（全麦面包、燕麦、糙米）、蛋白质（鸡蛋、酸奶、坚果）和水果开始新的一天。早餐能为您进行塔瓦夫（Tawaf）、萨伊（Sa'i）和长途跋涉保持充沛的体力。",
      "ja": "複合炭水化物（全粒パン、オーツ麦、玄米）、タンパク質（卵、ヨーグルト、ナッツ）、果物で一日を始めましょう。朝食はタワーフ（Tawaf）、サイー（Sa'i）、長い移動のためのエネルギーを維持します。",
      "ko": "복합 탄수화물(통곡물 빵, 귀리, 현미), 단백질(달걀, 요거트, 견과류), 과일로 하루를 시작하세요. 아침 식사는 타와프(Tawaf), 사이(Sa'i), 그리고 긴 여정을 위한 에너지를 유지해 줍니다.",
      "hi": "जटिल कार्बोहाइड्रेट (साबुत अनाज की रोटी, ओट्स, ब्राउन राइस), प्रोटीन (अंडे, दही, मेवे) और फल के साथ दिन की शुरुआत करें। नाश्ता तवाफ (Tawaf), सई (Sa'i) और लंबी यात्राओं के लिए आपकी ऊर्जा बनाए रखता है।"
    }
  },
  {
    "id": "kurma",
    "icon": "Apple",
    "tag": "sunnah",
    "title": {
      "id": "Kurma dan air zamzam — sunnah yang menyehatkan",
      "en": "Dates and Zamzam water — a Sunnah that promotes good health",
      "ar": "التمر وماء زمزم — سنّة نبوية مفيدة للصحة",
      "fr": "Dattes et eau de Zamzam — une Sunna bénéfique pour la santé",
      "de": "Datteln und Zamzam-Wasser — eine gesundheitsfördernde Sunnah",
      "es": "Dátiles y agua zamzam — una Sunnah que promueve la buena salud",
      "ru": "Финики и вода Замзам — Сунна, способствующая здоровью",
      "zh": "椰枣与渗渗泉水——有益健康的圣行（Sunnah）",
      "ja": "ナツメヤシとザムザム水 — 健康を促すスンナ（Sunnah）",
      "ko": "대추야자와 잠잠수(Zamzam) — 건강을 증진하는 순나(Sunnah)",
      "hi": "खजूर और ज़मज़म पानी — स्वास्थ्यवर्धक सुन्नत (Sunnah)"
    },
    "body": {
      "id": "Kurma kaya kalium, serat, dan gula alami untuk energi cepat; 3–7 butir sehari sudah cukup. Minumlah zamzam sambil berdoa, dianjurkan duduk atau menghadap kiblat dan bernapas tiga kali di antara tegukan.",
      "en": "Dates are rich in potassium, fibre, and natural sugars for quick energy; 3–7 dates a day is sufficient. Drink Zamzam water while making du'a, preferably while seated or facing the Qiblah, and breathe three times between sips.",
      "ar": "التمر غنيٌّ بالبوتاسيوم والألياف والسكريات الطبيعية لإمداد الجسم بالطاقة السريعة؛ ويكفي تناول 3–7 تمرات يومياً. اشرب ماء زمزم أثناء الدعاء، ويُستحب أن تكون جالساً أو مستقبلاً القبلة، وتتنفس ثلاث مرات بين الجرعات.",
      "fr": "Les dattes sont riches en potassium, en fibres et en sucres naturels pour un apport rapide en énergie ; 3 à 7 dattes par jour suffisent. Buvez l'eau de Zamzam en faisant du'a, de préférence assis ou face à la Qiblah, en reprenant votre souffle trois fois entre les gorgées.",
      "de": "Datteln sind reich an Kalium, Ballaststoffen und natürlichem Zucker für schnelle Energie; 3–7 Datteln pro Tag sind ausreichend. Trinken Sie Zamzam-Wasser beim Du'a-Sprechen, vorzugsweise im Sitzen oder mit Blick zur Qiblah, und atmen Sie zwischen den Schlucken dreimal.",
      "es": "Los dátiles son ricos en potasio, fibra y azúcares naturales para obtener energía rápida; con 3–7 dátiles al día es suficiente. Beba el agua de Zamzam mientras hace du'a, preferiblemente sentado o mirando hacia la Qiblah, y respire tres veces entre cada sorbo.",
      "ru": "Финики богаты калием, клетчаткой и натуральными сахарами для быстрого получения энергии; достаточно 3–7 фиников в день. Пейте воду Замзам во время ду'а, желательно сидя или повернувшись лицом к Кибле, делая три вдоха между глотками.",
      "zh": "椰枣富含钾、膳食纤维和天然糖分，能快速补充能量；每天吃3至7颗即可。饮用渗渗泉水（Zamzam）时请同时祈祷（du'a），建议坐着或面朝朝拜方向（Qiblah），并在每次饮用之间呼吸三次。",
      "ja": "ナツメヤシはカリウム、食物繊維、天然糖が豊富で素早いエネルギー補給に適しています。1日3〜7粒で十分です。ザムザム水（Zamzam）はドゥアー（du'a）を唱えながら、できれば座った状態またはキブラ（Qiblah）に向かって飲み、各ひと口の間に三回呼吸をしてください。",
      "ko": "대추야자는 칼륨, 식이섬유, 천연 당분이 풍부하여 빠른 에너지 보충에 좋으며, 하루 3~7알이면 충분합니다. 잠잠수(Zamzam)는 두아(du'a)를 하며 마시되, 가능하면 앉거나 끼블라(Qiblah) 방향을 향해 마시고, 한 모금씩 마실 때마다 세 번 숨을 쉬세요.",
      "hi": "खजूर पोटेशियम, फाइबर और प्राकृतिक शर्करा से भरपूर होते हैं, जो त्वरित ऊर्जा प्रदान करते हैं; प्रतिदिन 3–7 खजूर पर्याप्त हैं। ज़मज़म पानी दुआ करते हुए पिएं, अधिमानतः बैठकर या क़िब्ला (Qiblah) की ओर मुंह करके, और हर घूंट के बीच तीन बार सांस लें।"
    }
  },
  {
    "id": "piring",
    "icon": "Salad",
    "tag": "sunnah",
    "title": {
      "id": "Piring seimbang: ½ sayur & buah, ¼ protein, ¼ karbohidrat",
      "en": "Balanced plate: ½ vegetables & fruits, ¼ protein, ¼ carbohydrates",
      "ar": "الطبق المتوازن: ½ خضروات وفواكه، ¼ بروتين، ¼ كربوهيدرات",
      "fr": "Assiette équilibrée : ½ légumes & fruits, ¼ protéines, ¼ glucides",
      "de": "Ausgewogener Teller: ½ Gemüse & Obst, ¼ Protein, ¼ Kohlenhydrate",
      "es": "Plato equilibrado: ½ verduras y frutas, ¼ proteínas, ¼ carbohidratos",
      "ru": "Сбалансированная тарелка: ½ овощи и фрукты, ¼ белки, ¼ углеводы",
      "zh": "均衡餐盘：½蔬菜和水果，¼蛋白质，¼碳水化合物",
      "ja": "バランスの取れた食事：½野菜と果物、¼タンパク質、¼炭水化物",
      "ko": "균형 잡힌 식판: ½ 채소 및 과일, ¼ 단백질, ¼ 탄수화물",
      "hi": "संतुलित थाली: ½ सब्जियाँ और फल, ¼ प्रोटीन, ¼ कार्बोहाइड्रेट"
    },
    "body": {
      "id": "Isi setengah piring dengan sayur dan buah, seperempat protein rendah lemak (ikan, ayam, kacang-kacangan), seperempat nasi atau roti. Ikuti sunnah berhenti sebelum kenyang: sepertiga makanan, sepertiga minuman, sepertiga udara.",
      "en": "Fill half the plate with vegetables and fruits, a quarter with low-fat protein (fish, chicken, legumes), and a quarter with rice or bread. Follow the Sunnah of stopping before being full: one third food, one third drink, one third air.",
      "ar": "املأ نصف الطبق بالخضروات والفواكه، وربعه ببروتين قليل الدهون (سمك، دجاج، بقوليات)، وربعه بالأرز أو الخبز. اتبع السنة النبوية بالتوقف قبل الشبع: ثلث للطعام، وثلث للشراب، وثلث للنفَس.",
      "fr": "Remplissez la moitié de l'assiette avec des légumes et des fruits, un quart avec des protéines faibles en graisses (poisson, poulet, légumineuses), et un quart avec du riz ou du pain. Suivez la Sunnah de s'arrêter avant d'être rassasié : un tiers de nourriture, un tiers de boisson, un tiers d'air.",
      "de": "Füllen Sie die Hälfte des Tellers mit Gemüse und Obst, ein Viertel mit fettarmem Protein (Fisch, Hähnchen, Hülsenfrüchte) und ein Viertel mit Reis oder Brot. Befolgen Sie die Sunnah, vor der Sättigung aufzuhören: ein Drittel Essen, ein Drittel Trinken, ein Drittel Luft.",
      "es": "Llena la mitad del plato con verduras y frutas, un cuarto con proteínas bajas en grasa (pescado, pollo, legumbres) y un cuarto con arroz o pan. Sigue la Sunnah de detenerse antes de saciarse: un tercio de comida, un tercio de bebida, un tercio de aire.",
      "ru": "Заполните половину тарелки овощами и фруктами, четверть — нежирным белком (рыба, курица, бобовые), четверть — рисом или хлебом. Следуйте Сунне — останавливайтесь до насыщения: одна треть еды, одна треть питья, одна треть воздуха.",
      "zh": "将餐盘的一半装满蔬菜和水果，四分之一装低脂蛋白质（鱼、鸡肉、豆类），四分之一装米饭或面包。遵循圣行，在吃饱之前停下：三分之一食物，三分之一饮料，三分之一空气。",
      "ja": "皿の半分を野菜と果物で満たし、四分の一を低脂肪タンパク質（魚、鶏肉、豆類）、四分の一をご飯またはパンにしてください。満腹になる前に食べるのをやめるスンナに従いましょう：三分の一は食べ物、三分の一は飲み物、三分の一は空気。",
      "ko": "접시의 절반은 채소와 과일로, 4분의 1은 저지방 단백질(생선, 닭고기, 콩류)로, 4분의 1은 밥이나 빵으로 채우십시오. 배부르기 전에 멈추는 순나를 따르십시오: 3분의 1은 음식, 3분의 1은 음료, 3분의 1은 공기.",
      "hi": "आधी थाली सब्जियों और फलों से भरें, एक चौथाई कम वसा वाले प्रोटीन (मछली, चिकन, फलियाँ) से, और एक चौथाई चावल या रोटी से। भरपेट खाने से पहले रुकने की सुन्नत का पालन करें: एक तिहाई खाना, एक तिहाई पानी, एक तिहाई हवा।"
    }
  },
  {
    "id": "gorengan",
    "icon": "Flame",
    "tag": "",
    "title": {
      "id": "Kurangi gorengan, pedas, dan bersantan",
      "en": "Reduce fried, spicy, and coconut milk-based foods",
      "ar": "تقليل المقليات والأطعمة الحارة والمطبوخة بالحليب الناريّل",
      "fr": "Réduire les fritures, les plats épicés et à base de lait de coco",
      "de": "Reduzieren Sie gebratene, scharfe und Kokosmilch-haltige Speisen",
      "es": "Reduzca los fritos, los alimentos picantes y los elaborados con leche de coco",
      "ru": "Сократите жареную, острую пищу и блюда на основе кокосового молока",
      "zh": "减少油炸食品、辛辣食物和含椰浆的食物",
      "ja": "揚げ物、辛い食べ物、ココナッツミルクを使った料理を控える",
      "ko": "튀긴 음식, 매운 음식, 코코넛 밀크 요리 줄이기",
      "hi": "तले हुए, मसालेदार और नारियल दूध वाले खाद्य पदार्थ कम करें"
    },
    "body": {
      "id": "Makanan berminyak, terlalu pedas, atau bersantan memicu mulas, diare, dan asam lambung yang mengganggu ibadah. Pilih menu rebus, kukus, atau bakar.",
      "en": "Oily, overly spicy, or coconut milk-based foods can trigger heartburn, diarrhea, and acid reflux that disrupt worship. Choose boiled, steamed, or grilled menus instead.",
      "ar": "الأطعمة الدهنية أو الحارة جداً أو المطبوخة بحليب جوز الهند قد تسبب حرقة المعدة والإسهال وارتجاع الحمض مما يُخِل بأداء العبادة. اختر الأطعمة المسلوقة أو المطهوة على البخار أو المشوية بدلاً من ذلك.",
      "fr": "Les aliments gras, trop épicés ou à base de lait de coco peuvent provoquer des brûlures d'estomac, de la diarrhée et des reflux acides qui perturbent l'adoration. Choisissez plutôt des menus bouillis, cuits à la vapeur ou grillés.",
      "de": "Fettige, übermäßig scharfe oder auf Kokosmilch basierende Speisen können Sodbrennen, Durchfall und Säurereflux verursachen, die die Andacht beeinträchtigen. Wählen Sie stattdessen gekochte, gedämpfte oder gegrillte Gerichte.",
      "es": "Los alimentos grasos, demasiado picantes o elaborados con leche de coco pueden provocar acidez, diarrea y reflujo ácido que interfieren con la adoración. Elija en su lugar menús hervidos, al vapor o a la parrilla.",
      "ru": "Жирная, чрезмерно острая пища или блюда на основе кокосового молока могут вызвать изжогу, диарею и кислотный рефлюкс, которые мешают поклонению. Выбирайте варёные, приготовленные на пару или жареные на гриле блюда.",
      "zh": "油腻、过于辛辣或含椰浆的食物会引发胃灼热、腹泻和胃酸反流，影响功课的进行。请选择水煮、蒸煮或烧烤的菜肴代替。",
      "ja": "油っこい食べ物、過度に辛い食べ物、またはココナッツミルクを使った料理は、胸焼け、下痢、逆流性食道炎を引き起こし、礼拝の妨げになることがあります。代わりに、茹でた、蒸した、または焼いた料理を選びましょう。",
      "ko": "기름진 음식, 지나치게 매운 음식, 또는 코코넛 밀크로 만든 음식은 속쓰림, 설사, 역류성 식도염을 유발하여 예배를 방해할 수 있습니다. 대신 삶거나, 찌거나, 구운 메뉴를 선택하십시오.",
      "hi": "तैलीय, अत्यधिक मसालेदार या नारियल दूध से बने खाद्य पदार्थ सीने में जलन, दस्त और एसिड रिफ्लक्स का कारण बन सकते हैं जो इबादत में बाधा डालते हैं। इसके बजाय उबले, भाप में पके या ग्रिल किए गए व्यंजन चुनें।"
    }
  },
  {
    "id": "protein",
    "icon": "Fish",
    "tag": "",
    "title": {
      "id": "Cukupi protein dan serat setiap hari",
      "en": "Meet your daily protein and fiber needs",
      "ar": "أوفِ احتياجاتك اليومية من البروتين والألياف",
      "fr": "Couvrez vos besoins quotidiens en protéines et en fibres",
      "de": "Decken Sie Ihren täglichen Protein- und Ballaststoffbedarf",
      "es": "Cubre tus necesidades diarias de proteínas y fibra",
      "ru": "Удовлетворяйте ежедневную потребность в белке и клетчатке",
      "zh": "每天摄取足够的蛋白质和膳食纤维",
      "ja": "毎日のタンパク質と食物繊維を十分に摂りましょう",
      "ko": "매일 단백질과 식이섬유를 충분히 섭취하세요",
      "hi": "प्रतिदिन प्रोटीन और फाइबर की पर्याप्त मात्रा लें"
    },
    "body": {
      "id": "Protein menjaga otot dari kelelahan (daging tanpa lemak, ikan, telur, lentil, hummus). Serat dari sayur, buah, kacang, dan biji-bijian mencegah sembelit yang sering terjadi saat perjalanan.",
      "en": "Protein keeps muscles from fatigue (lean meat, fish, eggs, lentils, hummus). Fiber from vegetables, fruits, nuts, and whole grains prevents constipation that commonly occurs during travel.",
      "ar": "البروتين يحمي العضلات من الإرهاق (اللحم الخالي من الدهون، السمك، البيض، العدس، الحمص). الألياف الموجودة في الخضروات والفواكه والمكسرات والحبوب الكاملة تمنع الإمساك الذي يحدث كثيرًا أثناء السفر.",
      "fr": "Les protéines protègent les muscles de la fatigue (viande maigre, poisson, œufs, lentilles, houmous). Les fibres provenant des légumes, fruits, noix et céréales complètes préviennent la constipation fréquente lors des voyages.",
      "de": "Protein schützt die Muskeln vor Erschöpfung (mageres Fleisch, Fisch, Eier, Linsen, Hummus). Ballaststoffe aus Gemüse, Obst, Nüssen und Vollkornprodukten beugen der Verstopfung vor, die während Reisen häufig auftritt.",
      "es": "Las proteínas protegen los músculos de la fatiga (carne magra, pescado, huevos, lentejas, hummus). La fibra de verduras, frutas, frutos secos y cereales integrales previene el estreñimiento que suele ocurrir durante los viajes.",
      "ru": "Белок защищает мышцы от усталости (нежирное мясо, рыба, яйца, чечевица, хумус). Клетчатка из овощей, фруктов, орехов и цельнозерновых продуктов предотвращает запоры, которые часто возникают во время путешествий.",
      "zh": "蛋白质能防止肌肉疲劳（瘦肉、鱼、鸡蛋、扁豆、鹰嘴豆泥）。来自蔬菜、水果、坚果和全谷物的膳食纤维可预防旅途中常见的便秘。",
      "ja": "タンパク質は筋肉の疲労を防ぎます（赤身肉、魚、卵、レンズ豆、フムス）。野菜、果物、ナッツ、全粒穀物からの食物繊維は、旅行中によく起こる便秘を防ぎます。",
      "ko": "단백질은 근육 피로를 예방합니다(저지방 육류, 생선, 달걀, 렌틸콩, 후무스). 채소, 과일, 견과류, 통곡물의 식이섬유는 여행 중 자주 발생하는 변비를 예방합니다.",
      "hi": "प्रोटीन मांसपेशियों को थकान से बचाता है (कम वसा वाला मांस, मछली, अंडे, दाल, हुम्मस)। सब्जियों, फलों, मेवों और साबुत अनाज से मिलने वाला फाइबर यात्रा के दौरान अक्सर होने वाली कब्ज को रोकता है।"
    }
  },
  {
    "id": "buah",
    "icon": "Droplets",
    "tag": "",
    "title": {
      "id": "Buah dan sayur berair untuk hidrasi",
      "en": "Hydrating fruits and vegetables for fluid replenishment",
      "ar": "الفواكه والخضروات المائية لتعويض السوائل",
      "fr": "Fruits et légumes gorgés d'eau pour une hydratation optimale",
      "de": "Wasserreiche Früchte und Gemüse zur Flüssigkeitszufuhr",
      "es": "Frutas y verduras hidratantes para reponer líquidos",
      "ru": "Сочные фрукты и овощи для восстановления водного баланса",
      "zh": "多汁水果和蔬菜助你补充水分",
      "ja": "水分補給のための水分豊富な果物と野菜",
      "ko": "수분 보충을 위한 수분이 많은 과일과 채소",
      "hi": "जलयोजन के लिए रसदार फल और सब्जियाँ"
    },
    "body": {
      "id": "Semangka, melon, jeruk, timun, dan tomat membantu mengganti cairan dan elektrolit yang hilang karena panas. Jadikan buah sebagai camilan utama.",
      "en": "Watermelon, melon, oranges, cucumber, and tomatoes help replenish fluids and electrolytes lost due to heat. Make fruit your primary snack.",
      "ar": "البطيخ والشمام والبرتقال والخيار والطماطم تساعد على تعويض السوائل والإلكتروليتات المفقودة بسبب الحرارة. اجعل الفاكهة وجبتك الخفيفة الرئيسية.",
      "fr": "La pastèque, le melon, les oranges, le concombre et les tomates aident à reconstituer les liquides et les électrolytes perdus à cause de la chaleur. Faites des fruits votre en-cas principal.",
      "de": "Wassermelone, Melone, Orangen, Gurke und Tomaten helfen dabei, Flüssigkeit und Elektrolyte zu ersetzen, die durch die Hitze verloren gehen. Machen Sie Obst zu Ihrem Hauptsnack.",
      "es": "La sandía, el melón, las naranjas, el pepino y los tomates ayudan a reponer los líquidos y electrolitos perdidos por el calor. Convierte la fruta en tu merienda principal.",
      "ru": "Арбуз, дыня, апельсины, огурец и помидоры помогают восполнить жидкость и электролиты, утраченные из-за жары. Сделайте фрукты своим основным перекусом.",
      "zh": "西瓜、哈密瓜、橙子、黄瓜和番茄有助于补充因高温流失的水分和电解质。将水果作为主要零食。",
      "ja": "スイカ、メロン、オレンジ、きゅうり、トマトは、暑さで失われた水分と電解質を補うのに役立ちます。果物をメインのおやつにしましょう。",
      "ko": "수박, 멜론, 오렌지, 오이, 토마토는 더위로 인해 손실된 수분과 전해질을 보충하는 데 도움이 됩니다. 과일을 주요 간식으로 삼으세요.",
      "hi": "तरबूज, खरबूजा, संतरा, खीरा और टमाटर गर्मी के कारण खोए हुए तरल पदार्थ और इलेक्ट्रोलाइट्स की भरपाई करने में मदद करते हैं। फल को अपना मुख्य नाश्ता बनाएं।"
    }
  },
  {
    "id": "camilan",
    "icon": "Cookie",
    "tag": "",
    "title": {
      "id": "Camilan sehat di tas",
      "en": "Healthy snacks in your bag",
      "ar": "وجبات خفيفة صحية في حقيبتك",
      "fr": "Collations saines dans votre sac",
      "de": "Gesunde Snacks in Ihrer Tasche",
      "es": "Bocadillos saludables en tu bolsa",
      "ru": "Полезные перекусы в вашей сумке",
      "zh": "包里备好健康零食",
      "ja": "バッグに健康的なスナックを",
      "ko": "가방 속 건강한 간식",
      "hi": "बैग में स्वस्थ नाश्ता"
    },
    "body": {
      "id": "Bawa kurma, kacang, buah kering, roti gandum, atau biskuit tinggi serat untuk mengganjal saat antre atau perjalanan panjang. Hindari camilan tinggi gula yang membuat cepat lemas.",
      "en": "Bring dates, nuts, dried fruit, whole-grain bread, or high-fiber biscuits to keep you going while queuing or on long journeys. Avoid high-sugar snacks that cause energy to drop quickly.",
      "ar": "احرص على حمل التمر والمكسرات والفواكه المجففة وخبز الحبوب الكاملة أو البسكويت الغني بالألياف لتعزيز طاقتك أثناء الانتظار أو السفر الطويل. تجنب الوجبات الخفيفة المرتفعة السكر التي تُسبب الإرهاق السريع.",
      "fr": "Emportez des dattes, des noix, des fruits secs, du pain complet ou des biscuits riches en fibres pour tenir lors des longues files d'attente ou des trajets prolongés. Évitez les collations riches en sucre qui provoquent une baisse d'énergie rapide.",
      "de": "Bringen Sie Datteln, Nüsse, getrocknete Früchte, Vollkornbrot oder ballaststoffreiche Kekse mit, um beim Anstehen oder auf langen Reisen gestärkt zu bleiben. Vermeiden Sie zuckerreiche Snacks, die schnell zu Erschöpfung führen.",
      "es": "Lleva dátiles, frutos secos, frutas deshidratadas, pan integral o galletas ricas en fibra para mantenerte activo durante las colas o los trayectos largos. Evita los bocadillos con alto contenido de azúcar que provocan una rápida pérdida de energía.",
      "ru": "Берите с собой финики, орехи, сухофрукты, цельнозерновой хлеб или богатое клетчаткой печенье, чтобы поддерживать силы в очередях или в долгих поездках. Избегайте высокосахарных закусок, которые быстро вызывают упадок сил.",
      "zh": "随身携带椰枣、坚果、干果、全麦面包或高纤维饼干，以便在排队或长途旅行中补充体力。避免食用高糖零食，以免体力迅速下降。",
      "ja": "列に並ぶ時や長旅の際にエネルギーを保つために、ナツメヤシ、ナッツ、ドライフルーツ、全粒パン、または食物繊維の豊富なビスケットを持参しましょう。素早く体力を消耗させる高糖質のスナックは避けてください。",
      "ko": "줄을 서거나 긴 여정 중에 체력을 유지하기 위해 대추야자, 견과류, 말린 과일, 통곡물 빵 또는 고섬유 비스킷을 챙기세요. 체력을 빠르게 떨어뜨리는 고당분 간식은 피하세요.",
      "hi": "कतार में खड़े रहने या लंबी यात्रा के दौरान ऊर्जा बनाए रखने के लिए खजूर, मेवे, सूखे मेवे, साबुत अनाज की रोटी या उच्च फाइबर बिस्किट साथ रखें। अधिक चीनी वाले स्नैक्स से बचें जो जल्दी थकान का कारण बनते हैं।"
    }
  },
  {
    "id": "kafein",
    "icon": "Coffee",
    "tag": "",
    "title": {
      "id": "Batasi kafein, teh manis, dan minuman bersoda",
      "en": "Limit caffeine, sweet tea, and carbonated drinks",
      "ar": "حدِّد استهلاك الكافيين والشاي المحلى والمشروبات الغازية",
      "fr": "Limitez la caféine, le thé sucré et les boissons gazeuses",
      "de": "Begrenzen Sie Koffein, süßen Tee und kohlensäurehaltige Getränke",
      "es": "Limita la cafeína, el té dulce y las bebidas carbonatadas",
      "ru": "Ограничьте потребление кофеина, сладкого чая и газированных напитков",
      "zh": "限制咖啡因、甜茶及碳酸饮料的摄入",
      "ja": "カフェイン、甘いお茶、炭酸飲料を控えましょう",
      "ko": "카페인, 달콤한 차, 탄산음료 섭취를 줄이세요",
      "hi": "कैफीन, मीठी चाय और कार्बोनेटेड पेय को सीमित करें"
    },
    "body": {
      "id": "Kafein dan gula tinggi bersifat diuretik dan memicu dehidrasi. Ganti dengan air putih, susu, atau jus tanpa gula; kopi atau teh cukup 1–2 cangkir sehari.",
      "en": "Caffeine and high sugar act as diuretics and trigger dehydration. Replace them with plain water, milk, or unsweetened juice; limit coffee or tea to just 1–2 cups per day.",
      "ar": "يعمل الكافيين والسكر المرتفع كمدرَّات للبول ويُسببان الجفاف. استبدلهما بالماء أو الحليب أو العصير غير المحلى، واكتفِ بكوب إلى كوبين من القهوة أو الشاي يومياً.",
      "fr": "La caféine et le sucre en excès ont un effet diurétique et favorisent la déshydratation. Remplacez-les par de l'eau nature, du lait ou des jus sans sucre ajouté; limitez le café ou le thé à 1 à 2 tasses par jour.",
      "de": "Koffein und hoher Zuckergehalt wirken harntreibend und begünstigen Dehydrierung. Ersetzen Sie diese durch stilles Wasser, Milch oder ungesüßten Saft; trinken Sie Kaffee oder Tee auf höchstens 1–2 Tassen pro Tag.",
      "es": "La cafeína y el alto contenido de azúcar actúan como diuréticos y provocan deshidratación. Sustitúyelos por agua, leche o jugos sin azúcar; limita el café o el té a solo 1–2 tazas al día.",
      "ru": "Кофеин и высокое содержание сахара обладают мочегонным действием и вызывают обезвоживание. Замените их обычной водой, молоком или соком без сахара; ограничьте потребление кофе или чая до 1–2 чашек в день.",
      "zh": "咖啡因和高糖饮料具有利尿作用，会引发脱水。请以白开水、牛奶或无糖果汁代替，咖啡或茶每天饮用不超过1–2杯。",
      "ja": "カフェインと高糖質は利尿作用があり、脱水を引き起こします。これらの代わりに水、牛乳、または無糖ジュースを飲むようにし、コーヒーや紅茶は1日1〜2杯にとどめましょう。",
      "ko": "카페인과 고당분은 이뇨 작용을 하여 탈수를 유발합니다. 이를 물, 우유 또는 무가당 주스로 대체하고 커피나 차는 하루 1–2잔으로 제한하세요.",
      "hi": "कैफीन और अधिक चीनी मूत्रवर्धक के रूप में काम करते हैं और निर्जलीकरण को बढ़ावा देते हैं। इन्हें सादे पानी, दूध या बिना चीनी के जूस से बदलें; कॉफी या चाय केवल दिन में 1–2 कप तक सीमित रखें।"
    }
  },
  {
    "id": "jadwal",
    "icon": "Clock",
    "tag": "",
    "title": {
      "id": "Makan teratur di sela waktu salat",
      "en": "Eat regularly between prayer times",
      "ar": "تناوَل الطعامَ بانتظام بين أوقات الصلاة",
      "fr": "Manger régulièrement entre les heures de prière",
      "de": "Regelmäßig zwischen den Gebetszeiten essen",
      "es": "Comer regularmente entre los tiempos de oración",
      "ru": "Регулярно питайтесь между временами намаза",
      "zh": "在礼拜时间之间规律进食",
      "ja": "礼拝の合間に規則正しく食事をする",
      "ko": "예배 시간 사이에 규칙적으로 식사하기",
      "hi": "नमाज़ के वक्तों के बीच नियमित रूप से खाना खाएं"
    },
    "body": {
      "id": "Makan porsi sedang tiga kali sehari plus camilan. Hindari makan berat tepat sebelum tawaf atau sa'i, dan pilih makan malam ringan agar tidur nyenyak dan mudah bangun untuk tahajud dan Subuh.",
      "en": "Eat moderate portions three times a day plus snacks. Avoid heavy meals right before Tawaf or Sa'i, and choose a light dinner so you can sleep well and easily wake up for Tahajjud and Fajr.",
      "ar": "تناوَل وجباتٍ متوسطة الحجم ثلاث مرات يومياً مع وجبات خفيفة. تجنَّب الأكل الثقيل مباشرةً قبل الطواف أو السعي، واختَر عشاءً خفيفاً لتنامَ جيداً وتستيقظَ بيسرٍ لصلاة التهجد والفجر.",
      "fr": "Mangez des portions modérées trois fois par jour avec des collations. Évitez les repas lourds juste avant le Tawaf ou le Sa'i, et choisissez un dîner léger pour bien dormir et vous réveiller facilement pour le Tahajjud et Fajr.",
      "de": "Essen Sie dreimal täglich moderate Portionen plus Snacks. Vermeiden Sie schwere Mahlzeiten kurz vor dem Tawaf oder Sa'i, und wählen Sie ein leichtes Abendessen, damit Sie gut schlafen und leicht für Tahajjud und Fajr aufwachen können.",
      "es": "Come porciones moderadas tres veces al día más aperitivos. Evita las comidas pesadas justo antes del Tawaf o el Sa'i, y elige una cena ligera para dormir bien y despertar fácilmente para el Tahajjud y el Fajr.",
      "ru": "Питайтесь умеренными порциями три раза в день плюс перекусы. Избегайте тяжёлой пищи непосредственно перед Тавафом или Са'и, и выбирайте лёгкий ужин, чтобы хорошо спать и легко просыпаться на Тахаджжуд и Фаджр.",
      "zh": "每天吃三顿适量的正餐加上小吃。避免在Tawaf或Sa'i之前吃太饱，并选择清淡的晚餐，以便睡得好、能轻松起床进行Tahajjud和Fajr礼拜。",
      "ja": "1日3回適量の食事とおやつを摂りましょう。TawafやSa'iの直前の食べ過ぎは避け、TahajjudとFajrのために目覚めやすく熟睡できるよう、夕食は軽めにしましょう。",
      "ko": "하루 세 번 적당한 양의 식사와 간식을 드세요. Tawaf나 Sa'i 직전에 과식을 피하고, Tahajjud와 Fajr를 위해 잘 자고 쉽게 일어날 수 있도록 저녁은 가볍게 드세요.",
      "hi": "दिन में तीन बार संतुलित मात्रा में खाना खाएं और बीच में हल्का नाश्ता लें। Tawaf या Sa'i से ठीक पहले भारी खाना खाने से बचें, और रात का खाना हल्का रखें ताकि नींद अच्छी आए और Tahajjud तथा Fajr के लिए आसानी से उठ सकें।"
    }
  },
  {
    "id": "higienis",
    "icon": "ShieldCheck",
    "tag": "",
    "title": {
      "id": "Jaga kebersihan dan keamanan makanan",
      "en": "Maintain food hygiene and safety",
      "ar": "حافِظ على نظافة الطعام وسلامته",
      "fr": "Maintenir l'hygiène et la sécurité alimentaires",
      "de": "Lebensmittelhygiene und -sicherheit wahren",
      "es": "Mantener la higiene y seguridad alimentaria",
      "ru": "Соблюдайте гигиену и безопасность питания",
      "zh": "保持食品卫生与安全",
      "ja": "食品の衛生と安全を保つ",
      "ko": "음식 위생과 안전 유지하기",
      "hi": "खाने की स्वच्छता और सुरक्षा बनाए रखें"
    },
    "body": {
      "id": "Pilih makanan yang dimasak matang dan masih hangat, cuci tangan sebelum makan, hindari makanan yang lama terbuka di suhu ruang, dan cuci buah dengan air bersih.",
      "en": "Choose foods that are thoroughly cooked and still warm, wash your hands before eating, avoid food that has been left open at room temperature for a long time, and wash fruit with clean water.",
      "ar": "اختَر الأطعمة المطبوخة جيداً والدافئة، واغسِل يديك قبل الأكل، وتجنَّب الطعام الذي بقي مكشوفاً في درجة حرارة الغرفة لفترة طويلة، واغسِل الفاكهة بالماء النظيف.",
      "fr": "Choisissez des aliments bien cuits et encore chauds, lavez-vous les mains avant de manger, évitez les aliments laissés longtemps à l'air libre à température ambiante, et lavez les fruits à l'eau propre.",
      "de": "Wählen Sie gut durchgegarte und noch warme Speisen, waschen Sie sich vor dem Essen die Hände, meiden Sie Lebensmittel, die lange offen bei Raumtemperatur standen, und waschen Sie Obst mit sauberem Wasser.",
      "es": "Elige alimentos bien cocidos y aún calientes, lávate las manos antes de comer, evita los alimentos que han estado expuestos durante mucho tiempo a temperatura ambiente, y lava la fruta con agua limpia.",
      "ru": "Выбирайте хорошо приготовленную и ещё тёплую пищу, мойте руки перед едой, избегайте продуктов, которые долго стояли открытыми при комнатной температуре, и мойте фрукты чистой водой.",
      "zh": "选择充分烹煮且仍温热的食物，饭前洗手，避免在室温下长时间敞放的食物，并用干净的水清洗水果。",
      "ja": "しっかりと加熱調理された温かい食べ物を選び、食前に手を洗い、室温で長時間放置された食べ物は避け、果物は清潔な水で洗いましょう。",
      "ko": "충분히 조리되어 아직 따뜻한 음식을 선택하고, 식사 전에 손을 씻고, 실온에 오래 방치된 음식을 피하며, 과일은 깨끗한 물로 씻으세요.",
      "hi": "अच्छी तरह पके हुए और अभी गर्म खाने को चुनें, खाने से पहले हाथ धोएं, लंबे समय तक कमरे के तापमान पर खुले रखे गए खाने से बचें, और फलों को साफ पानी से धोएं।"
    }
  },
  {
    "id": "penyakit",
    "icon": "Stethoscope",
    "tag": "medis",
    "title": {
      "id": "Bagi penderita diabetes, hipertensi, atau maag",
      "en": "For those with diabetes, hypertension, or gastritis",
      "ar": "لمن يعانون من مرض السكري أو ارتفاع ضغط الدم أو التهاب المعدة",
      "fr": "Pour les personnes atteintes de diabète, d'hypertension ou de gastrite",
      "de": "Für Personen mit Diabetes, Bluthochdruck oder Magenproblemen",
      "es": "Para quienes padecen diabetes, hipertensión o gastritis",
      "ru": "Для страдающих диабетом, гипертонией или гастритом",
      "zh": "针对糖尿病、高血压或胃病患者",
      "ja": "糖尿病、高血圧、または胃炎をお持ちの方へ",
      "ko": "당뇨병, 고혈압 또는 위염이 있는 분들을 위해",
      "hi": "मधुमेह, उच्च रक्तचाप, या गैस्ट्राइटिस से पीड़ित लोगों के लिए"
    },
    "body": {
      "id": "Tetap patuhi jadwal makan dan obat, batasi garam dan gula, hindari perut kosong terlalu lama, dan konsultasikan menu dengan dokter atau petugas kesehatan rombongan.",
      "en": "Continue to follow your meal and medication schedule, limit salt and sugar intake, avoid going too long on an empty stomach, and consult your menu with a doctor or the group's healthcare officer.",
      "ar": "استمر في الالتزام بجدول وجباتك وأدويتك، وقلّل من تناول الملح والسكر، وتجنّب بقاء المعدة فارغة لفترة طويلة، واستشر طبيبك أو المسؤول الصحي في المجموعة بشأن نظامك الغذائي.",
      "fr": "Continuez à respecter votre horaire de repas et de médicaments, limitez le sel et le sucre, évitez de rester trop longtemps l'estomac vide, et consultez un médecin ou le responsable médical du groupe concernant votre alimentation.",
      "de": "Halten Sie weiterhin Ihren Mahlzeiten- und Medikamentenplan ein, reduzieren Sie Salz- und Zuckerkonsum, vermeiden Sie zu lange Nüchternphasen und besprechen Sie Ihren Speiseplan mit einem Arzt oder dem Sanitäter der Reisegruppe.",
      "es": "Continúe respetando su horario de comidas y medicamentos, limite la sal y el azúcar, evite estar demasiado tiempo con el estómago vacío y consulte su menú con un médico o el responsable de salud del grupo.",
      "ru": "Продолжайте соблюдать расписание приёма пищи и лекарств, ограничьте потребление соли и сахара, избегайте длительного голодания и проконсультируйтесь с врачом или медицинским работником группы относительно вашего рациона.",
      "zh": "继续遵守饮食和用药时间表，限制盐和糖的摄入，避免长时间空腹，并就饮食安排咨询医生或团队医疗人员。",
      "ja": "食事と服薬のスケジュールを守り、塩分と糖分を控え、長時間の空腹を避け、食事メニューについてはグループの医師または医療担当者に相談してください。",
      "ko": "식사 및 복약 일정을 계속 준수하고, 소금과 설탕 섭취를 제한하며, 공복 상태가 너무 오래 지속되지 않도록 하고, 식단에 대해 의사나 단체 의료 담당자와 상담하십시오.",
      "hi": "अपने भोजन और दवा के समय-सारणी का पालन करते रहें, नमक और चीनी का सेवन सीमित करें, बहुत देर तक खाली पेट रहने से बचें, और अपने आहार के बारे में डॉक्टर या समूह के स्वास्थ्य अधिकारी से परामर्श करें।"
    }
  }
];

export const EXERCISE_TIPS = [
  {
    "id": "jalan-persiapan",
    "icon": "Footprints",
    "tag": "persiapan",
    "title": {
      "id": "Latihan jalan kaki sebelum berangkat",
      "en": "Walking practice before departure",
      "ar": "التدريب على المشي قبل السفر",
      "fr": "Entraînement à la marche avant le départ",
      "de": "Gehtraining vor der Abreise",
      "es": "Entrenamiento de caminata antes de la partida",
      "ru": "Тренировка ходьбы перед отправлением",
      "zh": "出发前的步行练习",
      "ja": "出発前のウォーキング練習",
      "ko": "출발 전 걷기 연습",
      "hi": "प्रस्थान से पहले पैदल चलने का अभ्यास"
    },
    "body": {
      "id": "Tawaf dan sa'i saja bisa mencapai 5–7 km berjalan kaki. Biasakan jalan cepat 30–45 menit sehari, 4–8 minggu sebelum keberangkatan, agar kaki dan jantung siap.",
      "en": "Tawaf and Sa'i alone can cover 5–7 km on foot. Get used to brisk walking for 30–45 minutes a day, 4–8 weeks before departure, so that your legs and heart are ready.",
      "ar": "الطواف والسعي وحدهما قد يصلان إلى 5–7 كيلومترات مشياً على الأقدام. اعتد على المشي السريع لمدة 30–45 دقيقة يومياً، قبل 4–8 أسابيع من السفر، حتى تكون قدماك وقلبك على أتم استعداد.",
      "fr": "Le Tawaf et le Sa'i à eux seuls peuvent représenter 5 à 7 km à pied. Habituez-vous à marcher d'un pas vif pendant 30 à 45 minutes par jour, 4 à 8 semaines avant le départ, afin que vos jambes et votre cœur soient prêts.",
      "de": "Tawaf und Sa'i allein können 5–7 km zu Fuß umfassen. Gewöhnen Sie sich 4–8 Wochen vor der Abreise an täglich 30–45 Minuten zügiges Gehen, damit Ihre Beine und Ihr Herz vorbereitet sind.",
      "es": "El Tawaf y el Sa'i por sí solos pueden suponer 5–7 km a pie. Acostúmbrese a caminar a paso rápido durante 30–45 minutos al día, entre 4 y 8 semanas antes de la partida, para que sus piernas y su corazón estén preparados.",
      "ru": "Таваф и Са'й вместе могут составлять от 5 до 7 км пешком. Приучайте себя к быстрой ходьбе по 30–45 минут в день за 4–8 недель до отправления, чтобы ноги и сердце были готовы.",
      "zh": "单是塔瓦夫和萨伊就可能需要步行5至7公里。在出发前4至8周，每天坚持快走30至45分钟，让双腿和心脏做好充分准备。",
      "ja": "タワーフとサアイだけで5〜7kmを歩くことになります。出発の4〜8週間前から、毎日30〜45分の早歩きを習慣づけ、足と心臓の準備を整えましょう。",
      "ko": "타와프와 사이만으로도 5~7km를 걷게 됩니다. 출발 4~8주 전부터 하루 30~45분씩 빠른 걷기를 습관화하여 다리와 심장이 준비될 수 있도록 하십시오.",
      "hi": "अकेले तवाफ और सा'ई में ही 5–7 किलोमीटर पैदल चलना पड़ सकता है। प्रस्थान से 4–8 सप्ताह पहले से प्रतिदिन 30–45 मिनट तेज़ चलने की आदत डालें, ताकि आपके पैर और हृदय तैयार रहें।"
    }
  },
  {
    "id": "pemanasan",
    "icon": "Activity",
    "tag": "",
    "title": {
      "id": "Pemanasan dan peregangan sebelum tawaf dan sa'i",
      "en": "Warm-up and stretching before Tawaf and Sa'i",
      "ar": "الإحماء والتمدد قبل الطواف والسعي",
      "fr": "Échauffement et étirements avant le Tawaf et le Sa'i",
      "de": "Aufwärmen und Dehnen vor dem Tawaf und Sa'i",
      "es": "Calentamiento y estiramiento antes del Tawaf y el Sa'i",
      "ru": "Разминка и растяжка перед Тавафом и Са'и",
      "zh": "塔瓦夫和萨伊前的热身与拉伸",
      "ja": "タワーフとサイの前のウォームアップとストレッチ",
      "ko": "타와프와 사이 전 준비운동 및 스트레칭",
      "hi": "तवाफ़ और सई से पहले वार्म-अप और स्ट्रेचिंग"
    },
    "body": {
      "id": "Luangkan 5 menit untuk meregangkan betis, paha, punggung, dan bahu sebelum masuk area tawaf. Ini mengurangi risiko kram dan cedera saat berdesakan.",
      "en": "Take 5 minutes to stretch your calves, thighs, back, and shoulders before entering the Tawaf area. This reduces the risk of cramps and injuries when in crowded conditions.",
      "ar": "خصِّص 5 دقائق لتمديد عضلات الساق والفخذين والظهر والكتفين قبل دخول منطقة الطواف. فذلك يقلل من خطر التشنجات والإصابات عند الازدحام.",
      "fr": "Prenez 5 minutes pour étirer vos mollets, cuisses, dos et épaules avant d'entrer dans la zone de Tawaf. Cela réduit le risque de crampes et de blessures dans la foule.",
      "de": "Nehmen Sie sich 5 Minuten, um Wade, Oberschenkel, Rücken und Schultern zu dehnen, bevor Sie den Tawaf-Bereich betreten. Dies verringert das Risiko von Krämpfen und Verletzungen in der Menschenmenge.",
      "es": "Tómate 5 minutos para estirar las pantorrillas, los muslos, la espalda y los hombros antes de entrar al área del Tawaf. Esto reduce el riesgo de calambres y lesiones en situaciones de aglomeración.",
      "ru": "Уделите 5 минут растяжке икр, бёдер, спины и плеч перед входом в зону Тавафа. Это снижает риск судорог и травм в условиях столпотворения.",
      "zh": "在进入塔瓦夫区域前，花5分钟拉伸小腿、大腿、背部和肩膀。这能减少在拥挤环境中抽筋和受伤的风险。",
      "ja": "タワーフエリアに入る前に、5分間かけてふくらはぎ、太もも、背中、肩をストレッチしましょう。混雑した状況での痙攣や怪我のリスクを軽減します。",
      "ko": "타와프 구역에 들어가기 전에 5분간 종아리, 허벅지, 등, 어깨를 스트레칭하십시오. 이는 혼잡한 상황에서 쥐가 나거나 부상을 입을 위험을 줄여줍니다.",
      "hi": "तवाफ़ क्षेत्र में प्रवेश करने से पहले 5 मिनट पिंडली, जाँघ, पीठ और कंधों को स्ट्रेच करें। इससे भीड़भाड़ में ऐंठन और चोट का खतरा कम होता है।"
    }
  },
  {
    "id": "jalan-masjid",
    "icon": "Sun",
    "tag": "",
    "title": {
      "id": "Jalan santai ke masjid sebagai olahraga harian",
      "en": "A leisurely walk to the mosque as daily exercise",
      "ar": "المشي الهادئ إلى المسجد كرياضة يومية",
      "fr": "Une promenade tranquille vers la mosquée comme exercice quotidien",
      "de": "Ein gemächlicher Spaziergang zur Moschee als tägliche Bewegung",
      "es": "Una caminata tranquila a la mezquita como ejercicio diario",
      "ru": "Неспешная прогулка до мечети как ежедневная физическая нагрузка",
      "zh": "悠闲步行前往清真寺作为日常锻炼",
      "ja": "日課の運動としてモスクへの散歩",
      "ko": "일상 운동으로서 모스크까지 여유로운 산책",
      "hi": "दैनिक व्यायाम के रूप में मस्जिद तक इत्मीनान से पैदल चलना"
    },
    "body": {
      "id": "Berjalan kaki ke masjid 20–30 menit saat udara sejuk (setelah Subuh atau malam) adalah olahraga ringan yang cukup. Hindari berjalan jauh di bawah terik pukul 11.00–16.00.",
      "en": "Walking to the mosque for 20–30 minutes when the air is cool (after Fajr or at night) is sufficient light exercise. Avoid walking long distances under the intense heat between 11:00–16:00.",
      "ar": "المشي إلى المسجد لمدة 20–30 دقيقة في الأوقات الباردة (بعد الفجر أو في الليل) يُعدّ رياضةً خفيفةً كافية. تجنّب المشي لمسافات طويلة تحت أشعة الشمس الحارقة بين الساعة 11:00 و16:00.",
      "fr": "Marcher vers la mosquée pendant 20 à 30 minutes lorsqu'il fait frais (après Fajr ou le soir) constitue un exercice léger suffisant. Évitez de marcher de longues distances sous la chaleur intense entre 11h00 et 16h00.",
      "de": "20–30 Minuten zur Moschee zu laufen, wenn die Luft kühl ist (nach dem Fajr-Gebet oder abends), ist ausreichende leichte Bewegung. Vermeiden Sie lange Wege bei intensiver Hitze zwischen 11:00 und 16:00 Uhr.",
      "es": "Caminar a la mezquita durante 20 a 30 minutos cuando el aire está fresco (después del Fajr o por la noche) es un ejercicio ligero suficiente. Evite caminar largas distancias bajo el calor intenso entre las 11:00 y las 16:00.",
      "ru": "Ходьба до мечети в течение 20–30 минут в прохладное время (после Фаджра или ночью) является достаточной лёгкой нагрузкой. Избегайте длительных прогулок под палящим солнцем в период с 11:00 до 16:00.",
      "zh": "在凉爽时段（法吉尔礼拜后或夜间）步行20至30分钟前往清真寺，是足够的轻度运动。避免在11:00至16:00烈日下长距离行走。",
      "ja": "涼しい時間帯（ファジュル後または夜間）にモスクまで20〜30分歩くことは、十分な軽い運動になります。11:00〜16:00の強い日差しの下での長距離歩行は避けてください。",
      "ko": "공기가 서늘한 시간대(파즈르 후 또는 밤)에 모스크까지 20~30분간 걷는 것은 충분한 가벼운 운동입니다. 오전 11시부터 오후 4시 사이의 강한 더위 속에서 장거리 보행은 피하십시오.",
      "hi": "ठंडे मौसम में (फज्र के बाद या रात में) मस्जिद तक 20–30 मिनट पैदल चलना पर्याप्त हल्का व्यायाम है। सुबह 11:00 से शाम 4:00 बजे के बीच कड़ी धूप में लंबी दूरी तक चलने से बचें।"
    }
  },
  {
    "id": "peregangan-kamar",
    "icon": "PersonStanding",
    "tag": "",
    "title": {
      "id": "Peregangan ringan di kamar pagi dan malam",
      "en": "Light stretching in the room morning and evening",
      "ar": "تمطط خفيف في الغرفة صباحاً ومساءً",
      "fr": "Étirements légers dans la chambre matin et soir",
      "de": "Leichtes Dehnen im Zimmer morgens und abends",
      "es": "Estiramientos ligeros en la habitación por la mañana y por la noche",
      "ru": "Лёгкая растяжка в комнате утром и вечером",
      "zh": "早晚在房间内进行轻度伸展运动",
      "ja": "朝晩の部屋での軽いストレッチ",
      "ko": "아침저녁 방에서 하는 가벼운 스트레칭",
      "hi": "सुबह और शाम कमरे में हल्की स्ट्रेचिंग"
    },
    "body": {
      "id": "Gerakkan leher, bahu, punggung, pinggang, dan betis masing-masing 20–30 detik, total 5–10 menit. Membantu mengurangi pegal setelah berdiri dan berjalan lama.",
      "en": "Move your neck, shoulders, back, waist, and calves for 20–30 seconds each, totalling 5–10 minutes. This helps relieve soreness after prolonged standing and walking.",
      "ar": "حرِّك رقبتك وكتفيك وظهرك وخصرك وساقيك مدةَ 20–30 ثانية لكل منطقة، بإجمالي 5–10 دقائق. يساعد ذلك على تخفيف الإجهاد الناجم عن الوقوف والمشي الطويل.",
      "fr": "Mobilisez le cou, les épaules, le dos, la taille et les mollets pendant 20 à 30 secondes chacun, soit 5 à 10 minutes au total. Cela aide à réduire les courbatures après de longues périodes debout et de marche.",
      "de": "Bewegen Sie Nacken, Schultern, Rücken, Taille und Waden jeweils 20–30 Sekunden lang, insgesamt 5–10 Minuten. Dies hilft, Muskelkater nach längerem Stehen und Gehen zu lindern.",
      "es": "Mueve el cuello, los hombros, la espalda, la cintura y las pantorrillas durante 20 a 30 segundos cada uno, con un total de 5 a 10 minutos. Ayuda a reducir el cansancio muscular tras estar de pie y caminar durante mucho tiempo.",
      "ru": "Двигайте шеей, плечами, спиной, поясницей и икрами по 20–30 секунд каждую зону, всего 5–10 минут. Это помогает снять усталость после длительного стояния и ходьбы.",
      "zh": "分别活动颈部、肩部、背部、腰部和小腿各20–30秒，共计5–10分钟，有助于缓解长时间站立和行走后的酸痛。",
      "ja": "首・肩・背中・腰・ふくらはぎをそれぞれ20〜30秒ずつ動かし、合計5〜10分行います。長時間の立ち仕事や歩行後のだるさを和らげるのに役立ちます。",
      "ko": "목, 어깨, 등, 허리, 종아리를 각각 20–30초씩 움직여 총 5–10분간 스트레칭하세요. 오랜 시간 서 있거나 걷고 난 뒤의 근육통을 완화하는 데 도움이 됩니다.",
      "hi": "गर्दन, कंधे, पीठ, कमर और पिंडलियों को प्रत्येक को 20–30 सेकंड तक हिलाएं, कुल 5–10 मिनट। इससे लंबे समय तक खड़े रहने और चलने के बाद की थकान व दर्द कम करने में मदद मिलती है।"
    }
  },
  {
    "id": "kaki-lansia",
    "icon": "Accessibility",
    "tag": "lansia",
    "title": {
      "id": "Latihan kaki dan keseimbangan untuk lansia",
      "en": "Leg and balance exercises for the elderly",
      "ar": "تمارين الساقين والتوازن لكبار السن",
      "fr": "Exercices pour les jambes et l'équilibre pour les personnes âgées",
      "de": "Bein- und Gleichgewichtsübungen für ältere Menschen",
      "es": "Ejercicios de piernas y equilibrio para personas mayores",
      "ru": "Упражнения для ног и равновесия для пожилых людей",
      "zh": "老年人腿部及平衡训练",
      "ja": "高齢者向けの脚と平衡感覚のトレーニング",
      "ko": "노인을 위한 다리 및 균형 운동",
      "hi": "बुजुर्गों के लिए पैर और संतुलन व्यायाम"
    },
    "body": {
      "id": "Duduk-berdiri dari kursi 10 kali, angkat tumit 15 kali, dan jalan di tempat 2 menit, dua kali sehari. Jangan ragu memakai kursi roda atau skuter saat tawaf dan sa'i bila lelah.",
      "en": "Sit-to-stand from a chair 10 times, raise your heels 15 times, and march in place for 2 minutes, twice a day. Do not hesitate to use a wheelchair or scooter during Tawaf and Sa'i when tired.",
      "ar": "قم بالجلوس والوقوف من الكرسي 10 مرات، وارفع كعبيك 15 مرة، وامشِ في مكانك 2 دقيقة، مرتين يومياً. لا تتردد في استخدام الكرسي المتحرك أو السكوتر أثناء الطواف والسعي عند الإعياء.",
      "fr": "Levez-vous et rasseyez-vous d'une chaise 10 fois, montez sur la pointe des pieds 15 fois et marchez sur place pendant 2 minutes, deux fois par jour. N'hésitez pas à utiliser un fauteuil roulant ou un scooter lors du Tawaf et du Sa'i en cas de fatigue.",
      "de": "Setzen Sie sich 10-mal aus einem Stuhl auf und stehen Sie wieder auf, heben Sie die Fersen 15-mal an und marschieren Sie 2 Minuten auf der Stelle – zweimal täglich. Scheuen Sie sich nicht, beim Tawaf und Sa'i einen Rollstuhl oder Scooter zu nutzen, wenn Sie müde sind.",
      "es": "Siéntese y levántese de una silla 10 veces, eleve los talones 15 veces y marche en el lugar durante 2 minutos, dos veces al día. No dude en usar una silla de ruedas o un scooter durante el Tawaf y el Sa'i cuando se sienta cansado.",
      "ru": "Вставайте со стула и садитесь обратно 10 раз, поднимайтесь на носки 15 раз и маршируйте на месте 2 минуты — дважды в день. Не стесняйтесь пользоваться инвалидной коляской или скутером во время Тавафа и Са'и при усталости.",
      "zh": "每天两次：从椅子上坐起站立10次、抬起脚跟15次、原地踏步2分钟。在进行Tawaf和Sa'i时若感到疲惫，请毫不犹豫地使用轮椅或代步车。",
      "ja": "椅子からの立ち座り10回、かかち上げ15回、その場での足踏み2分間を1日2セット行いましょう。TawafとSa'iの際に疲れたら、遠慮なく車椅子やスクーターを利用してください。",
      "ko": "의자에서 앉았다 일어서기 10회, 발뒤꿈치 들기 15회, 제자리 걷기 2분을 하루 두 번 실시하세요. Tawaf와 Sa'i 중 피로할 때는 주저하지 말고 휠체어나 스쿠터를 이용하세요.",
      "hi": "दिन में दो बार कुर्सी से बैठकर 10 बार उठें-बैठें, एड़ियाँ 15 बार उठाएं और 2 मिनट तक एक ही स्थान पर चलें। थकने पर Tawaf और Sa'i के दौरान व्हीलचेयर या स्कूटर उपयोग करने में संकोच न करें।"
    }
  },
  {
    "id": "napas",
    "icon": "Wind",
    "tag": "",
    "title": {
      "id": "Latihan pernapasan dan relaksasi",
      "en": "Breathing and relaxation exercises",
      "ar": "تمارين التنفس والاسترخاء",
      "fr": "Exercices de respiration et de relaxation",
      "de": "Atem- und Entspannungsübungen",
      "es": "Ejercicios de respiración y relajación",
      "ru": "Упражнения для дыхания и расслабления",
      "zh": "呼吸与放松练习",
      "ja": "呼吸法とリラクゼーションの練習",
      "ko": "호흡 및 이완 운동",
      "hi": "श्वास और विश्राम अभ्यास"
    },
    "body": {
      "id": "Saat antre atau menunggu, tarik napas 4 hitungan, tahan 7, hembuskan 8, ulangi 4 kali. Menenangkan jantung, mengurangi stres, dan menjaga fokus ibadah.",
      "en": "While queuing or waiting, inhale for 4 counts, hold for 7, exhale for 8, and repeat 4 times. This calms the heart, reduces stress, and helps maintain focus in worship.",
      "ar": "أثناء الانتظار في الطابور، استنشق لأربع عدّات، احبس النفس لسبع، ثم أخرجه لثماني عدّات، وكرر ذلك أربع مرات. يهدئ هذا القلب، ويقلل التوتر، ويساعد على الحفاظ على التركيز في العبادة.",
      "fr": "En faisant la queue ou en attendant, inspirez pendant 4 temps, retenez votre souffle pendant 7, expirez pendant 8, et répétez 4 fois. Cela apaise le cœur, réduit le stress et aide à maintenir la concentration dans l'adoration.",
      "de": "Beim Anstehen oder Warten: 4 Zählungen einatmen, 7 anhalten, 8 ausatmen und 4 Mal wiederholen. Dies beruhigt das Herz, reduziert Stress und hilft, den Fokus bei der Ibadah zu bewahren.",
      "es": "Mientras hace cola o espera, inhale durante 4 tiempos, retenga el aliento durante 7, exhale durante 8 y repita 4 veces. Esto calma el corazón, reduce el estrés y ayuda a mantener el enfoque en la adoración.",
      "ru": "В очереди или во время ожидания вдыхайте на 4 счёта, задерживайте дыхание на 7, выдыхайте на 8 и повторяйте 4 раза. Это успокаивает сердце, снижает стресс и помогает сохранять сосредоточенность в поклонении.",
      "zh": "在排队或等候时，吸气数4拍，屏息数7拍，呼气数8拍，重复4次。这能平静心神、减轻压力，并帮助保持礼拜时的专注。",
      "ja": "列に並んでいるときや待っているとき、4カウント吸って、7カウント止め、8カウント吐き出し、これを4回繰り返します。心を落ち着かせ、ストレスを軽減し、礼拝への集中を保つのに役立ちます。",
      "ko": "줄을 서거나 기다리는 동안 4박자로 들이쉬고, 7박자 동안 멈추고, 8박자로 내쉬며 4번 반복하세요. 이는 마음을 진정시키고, 스트레스를 줄이며, 예배에 대한 집중력을 유지하는 데 도움이 됩니다.",
      "hi": "कतार में खड़े होते या प्रतीक्षा करते समय, 4 गिनती तक श्वास लें, 7 तक रोकें, 8 तक छोड़ें और 4 बार दोहराएं। यह हृदय को शांत करता है, तनाव कम करता है और इबादत में ध्यान बनाए रखने में मदद करता है।"
    }
  },
  {
    "id": "istirahat",
    "icon": "Moon",
    "tag": "sunnah",
    "title": {
      "id": "Pemulihan: tidur cukup dan qailulah",
      "en": "Recovery: adequate sleep and qailulah",
      "ar": "التعافي: النوم الكافي والقيلولة",
      "fr": "Récupération : sommeil suffisant et qailulah",
      "de": "Erholung: ausreichend Schlaf und Qailulah",
      "es": "Recuperación: sueño adecuado y qailulah",
      "ru": "Восстановление: полноценный сон и кайлюля",
      "zh": "恢复：充足睡眠与盖卢拉（午休）",
      "ja": "回復：十分な睡眠とカイルーラ",
      "ko": "회복: 충분한 수면과 카일룰라",
      "hi": "पुनर्लाभ: पर्याप्त नींद और क़ैलूलह"
    },
    "body": {
      "id": "Tidur 6–7 jam setiap malam dan tidur siang singkat 20–30 menit (qailulah) mempercepat pemulihan otot dan membantu bangun untuk qiyamul lail.",
      "en": "Sleeping 6–7 hours each night and taking a short 20–30 minute afternoon nap (qailulah) speeds up muscle recovery and helps you rise for qiyamul lail.",
      "ar": "النوم من 6 إلى 7 ساعات كل ليلة وأخذ قيلولة قصيرة مدتها 20 إلى 30 دقيقة يُسرّعان من تعافي العضلات ويساعدان على القيام لقيام الليل.",
      "fr": "Dormir 6 à 7 heures chaque nuit et faire une courte sieste de 20 à 30 minutes (qailulah) accélère la récupération musculaire et vous aide à vous lever pour le qiyamul lail.",
      "de": "6–7 Stunden Nachtschlaf und ein kurzer Mittagsschlaf von 20–30 Minuten (Qailulah) beschleunigen die Muskelregeneration und helfen dabei, zum Qiyamul Lail aufzustehen.",
      "es": "Dormir de 6 a 7 horas cada noche y tomar una breve siesta de 20 a 30 minutos (qailulah) acelera la recuperación muscular y le ayuda a levantarse para el qiyamul lail.",
      "ru": "Сон продолжительностью 6–7 часов каждую ночь и короткий дневной сон на 20–30 минут (кайлюля) ускоряют восстановление мышц и помогают подняться для кыямул-лайл.",
      "zh": "每晚睡眠6至7小时，并进行20至30分钟的短暂午休（盖卢拉），有助于加快肌肉恢复，并帮助您起身进行卧姆拉夜礼（qiyamul lail）。",
      "ja": "毎晩6〜7時間の睡眠と、20〜30分の短い午後の昼寝（カイルーラ）を取ることで、筋肉の回復が促進され、キヤームル・ライルのために起きることができます。",
      "ko": "매일 밤 6~7시간의 수면과 20~30분의 짧은 낮잠(카일룰라)은 근육 회복을 촉진하고 키야물 라일을 위해 일어나는 데 도움을 줍니다.",
      "hi": "हर रात 6–7 घंटे की नींद और 20–30 मिनट की छोटी दोपहर की झपकी (क़ैलूलह) मांसपेशियों की रिकवरी को तेज़ करती है और क़ियामुल लैल के लिए उठने में मदद करती है।"
    }
  },
  {
    "id": "kaki",
    "icon": "HeartPulse",
    "tag": "",
    "title": {
      "id": "Rawat kaki setelah berjalan jauh",
      "en": "Take care of your feet after long walks",
      "ar": "اعتنِ بقدميك بعد المشي الطويل",
      "fr": "Prenez soin de vos pieds après de longues marches",
      "de": "Pflegen Sie Ihre Füße nach langen Märschen",
      "es": "Cuide sus pies después de caminar largas distancias",
      "ru": "Ухаживайте за ногами после долгих прогулок",
      "zh": "长途步行后护理双脚",
      "ja": "長距離歩行後に足をケアする",
      "ko": "장거리 보행 후 발 관리하기",
      "hi": "लंबी पैदल यात्रा के बाद पैरों की देखभाल करें"
    },
    "body": {
      "id": "Gunakan sandal empuk dan kaus kaki, periksa lecet setiap malam, rendam kaki dengan air hangat, dan segera obati luka kecil sebelum menjadi infeksi.",
      "en": "Use soft sandals and socks, check for blisters every night, soak your feet in warm water, and treat small wounds promptly before they become infected.",
      "ar": "استخدم صنادل ناعمة وجوارب، وافحص قدميك كل ليلة بحثاً عن البثور، وانقع قدميك في ماء دافئ، وعالج الجروح الصغيرة فوراً قبل أن تتحول إلى عدوى.",
      "fr": "Utilisez des sandales souples et des chaussettes, vérifiez les ampoules chaque soir, faites tremper vos pieds dans de l'eau chaude et traitez rapidement les petites plaies avant qu'elles ne s'infectent.",
      "de": "Tragen Sie weiche Sandalen und Socken, überprüfen Sie jeden Abend auf Blasen, weichen Sie Ihre Füße in warmem Wasser ein und behandeln Sie kleine Wunden sofort, bevor sie sich entzünden.",
      "es": "Use sandalias suaves y calcetines, revise si hay ampollas cada noche, remoje sus pies en agua tibia y trate las pequeñas heridas de inmediato antes de que se infecten.",
      "ru": "Используйте мягкие сандалии и носки, проверяйте ноги на наличие мозолей каждый вечер, делайте ванночки для ног в тёплой воде и немедленно лечите небольшие ранки, пока они не инфицировались.",
      "zh": "穿软底凉鞋和袜子，每晚检查是否有水泡，用温水泡脚，并及时处理小伤口，防止感染。",
      "ja": "柔らかいサンダルと靴下を使用し、毎晩水ぶくれがないか確認し、足を温かいお湯に浸して、小さな傷が感染する前に速やかに手当てしてください。",
      "ko": "부드러운 샌들과 양말을 착용하고, 매일 밤 물집이 생겼는지 확인하며, 발을 따뜻한 물에 담그고, 작은 상처가 감염되기 전에 즉시 치료하십시오.",
      "hi": "मुलायम चप्पल और मोज़े पहनें, हर रात छालों की जाँच करें, पैरों को गुनगुने पानी में भिगोएँ, और छोटे घावों का तुरंत उपचार करें ताकि वे संक्रमित न हों।"
    }
  },
  {
    "id": "batas",
    "icon": "AlertTriangle",
    "tag": "medis",
    "title": {
      "id": "Kenali batas tubuh Anda",
      "en": "Know your body's limits",
      "ar": "اعرف حدود جسدك",
      "fr": "Connaissez les limites de votre corps",
      "de": "Kennen Sie die Grenzen Ihres Körpers",
      "es": "Conozca los límites de su cuerpo",
      "ru": "Знайте пределы своего тела",
      "zh": "了解您的身体极限",
      "ja": "自分の身体の限界を知る",
      "ko": "자신의 신체 한계를 파악하세요",
      "hi": "अपने शरीर की सीमाओं को पहचानें"
    },
    "body": {
      "id": "Pusing, jantung berdebar, kram, atau napas pendek adalah tanda untuk berhenti, minum, dan berteduh. Jangan memaksakan diri — ibadah yang tertunda bisa diqadha, kesehatan tidak.",
      "en": "Dizziness, heart palpitations, cramps, or shortness of breath are signs to stop, drink, and seek shade. Do not push yourself — a delayed act of worship can be made up (qadha), but health cannot.",
      "ar": "الدوار وخفقان القلب والتشنجات أو ضيق التنفس كلها إشارات للتوقف والشرب واللجوء إلى الظل. لا تُرهق نفسك — العبادة المتأخرة يمكن قضاؤها، أما الصحة فلا.",
      "fr": "Les vertiges, les palpitations cardiaques, les crampes ou l'essoufflement sont des signes qu'il faut s'arrêter, s'hydrater et chercher de l'ombre. Ne vous forcez pas — un acte d'adoration différé peut être rattrapé (qadha), mais pas la santé.",
      "de": "Schwindel, Herzrasen, Krämpfe oder Kurzatmigkeit sind Zeichen dafür, innezuhalten, zu trinken und Schatten aufzusuchen. Überfordern Sie sich nicht — eine verzögerte Ibadah kann nachgeholt werden (Qadha), Gesundheit jedoch nicht.",
      "es": "El mareo, las palpitaciones, los calambres o la falta de aliento son señales para detenerse, hidratarse y buscar sombra. No se fuerce — un acto de adoración postergado puede recuperarse (qadha), pero la salud no.",
      "ru": "Головокружение, сердцебиение, судороги или одышка — это сигналы остановиться, выпить воды и найти тень. Не перегружайте себя — отложенное поклонение можно восполнить (када), а здоровье — нет.",
      "zh": "头晕、心悸、抽筋或呼吸急促是停下来、补水和寻找阴凉处的信号。不要强迫自己——延误的功课可以补做（嘎达），但健康无法弥补。",
      "ja": "めまい、動悸、けいれん、または息切れは、立ち止まり、水を飲み、日陰を求めるサインです。無理をしてはいけません — 遅れた礼拝はカダーとして補うことができますが、健康は取り戻せません。",
      "ko": "어지럼증, 심계항진, 경련 또는 호흡 곤란은 멈추고, 수분을 섭취하며, 그늘을 찾아야 한다는 신호입니다. 무리하지 마십시오 — 미뤄진 예배는 카다로 보충할 수 있지만, 건강은 그렇지 않습니다.",
      "hi": "चक्कर आना, दिल की धड़कन तेज़ होना, ऐंठन, या सांस फूलना — ये रुकने, पानी पीने और छाँव में जाने के संकेत हैं। खुद पर ज़ोर न डालें — विलंबित इबादत की क़ज़ा हो सकती है, लेकिन स्वास्थ्य की नहीं।"
    }
  }
];

export const WELLNESS_UI = {
  "dietTitle": {
    "id": "Pola Makan Seimbang di Tanah Suci",
    "en": "Balanced Diet in the Holy Land",
    "ar": "النظام الغذائي المتوازن في الأراضي المقدسة",
    "fr": "Alimentation équilibrée en Terre Sainte",
    "de": "Ausgewogene Ernährung im Heiligen Land",
    "es": "Alimentación equilibrada en Tierra Santa",
    "ru": "Сбалансированное питание на Святой Земле",
    "zh": "圣地均衡饮食",
    "ja": "聖地でのバランスの取れた食事",
    "ko": "성지에서의 균형 잡힌 식단",
    "hi": "पवित्र भूमि में संतुलित आहार"
  },
  "dietHint": {
    "id": "Agar tetap prima dan sehat selama beribadah",
    "en": "To stay in top condition and healthy during worship",
    "ar": "للحفاظ على اللياقة والصحة أثناء أداء العبادة",
    "fr": "Pour rester en pleine forme et en bonne santé pendant le culte",
    "de": "Um während der Verehrung in Bestform und gesund zu bleiben",
    "es": "Para mantenerse en óptimas condiciones y saludable durante la adoración",
    "ru": "Чтобы оставаться в отличной форме и здоровым во время поклонения",
    "zh": "在礼拜期间保持最佳状态和健康",
    "ja": "礼拝中に最高の状態と健康を維持するために",
    "ko": "예배 중 최상의 컨디션과 건강을 유지하기 위해",
    "hi": "इबादत के दौरान स्वस्थ और चुस्त-दुरुस्त बने रहने के लिए"
  },
  "exerciseTitle": {
    "id": "Olahraga & Aktivitas Fisik",
    "en": "Exercise & Physical Activity",
    "ar": "التمارين الرياضية والنشاط البدني",
    "fr": "Exercice et activité physique",
    "de": "Sport & körperliche Aktivität",
    "es": "Ejercicio y actividad física",
    "ru": "Упражнения и физическая активность",
    "zh": "运动与体育活动",
    "ja": "運動と身体活動",
    "ko": "운동 및 신체 활동",
    "hi": "व्यायाम और शारीरिक गतिविधि"
  },
  "exerciseHint": {
    "id": "Gerakan ringan yang aman selama Umrah dan Haji",
    "en": "Light movements that are safe during Umrah and Hajj",
    "ar": "حركات خفيفة وآمنة أثناء أداء العمرة والحج",
    "fr": "Mouvements légers et sécurisés pendant l'Umrah et le Hajj",
    "de": "Leichte Bewegungen, die während Umrah und Hajj sicher sind",
    "es": "Movimientos ligeros y seguros durante la Umrah y el Hajj",
    "ru": "Лёгкие движения, безопасные во время Умры и Хаджа",
    "zh": "在乌姆拉和朝觐期间安全的轻度运动",
    "ja": "ウムラとハッジ中に安全な軽い動き",
    "ko": "우므라와 하지 중 안전한 가벼운 동작",
    "hi": "उमरह और हज के दौरान सुरक्षित हल्की हरकतें"
  },
  "showAll": {
    "id": "Lihat semua ({n})",
    "en": "See all ({n})",
    "ar": "عرض الكل ({n})",
    "fr": "Voir tout ({n})",
    "de": "Alle anzeigen ({n})",
    "es": "Ver todo ({n})",
    "ru": "Показать все ({n})",
    "zh": "查看全部（{n}）",
    "ja": "すべて表示（{n}）",
    "ko": "모두 보기 ({n})",
    "hi": "सभी देखें ({n})"
  },
  "showLess": {
    "id": "Tampilkan lebih sedikit",
    "en": "Show less",
    "ar": "عرض أقل",
    "fr": "Afficher moins",
    "de": "Weniger anzeigen",
    "es": "Mostrar menos",
    "ru": "Показать меньше",
    "zh": "收起",
    "ja": "表示を減らす",
    "ko": "간략히 보기",
    "hi": "कम दिखाएं"
  },
  "tagSunnah": {
    "id": "Sunnah",
    "en": "Sunnah",
    "ar": "سنّة",
    "fr": "Sunnah",
    "de": "Sunnah",
    "es": "Sunnah",
    "ru": "Сунна",
    "zh": "圣行（Sunnah）",
    "ja": "スンナ（Sunnah）",
    "ko": "순나（Sunnah）",
    "hi": "सुन्नह（Sunnah）"
  },
  "tagPrep": {
    "id": "Persiapan",
    "en": "Preparation",
    "ar": "تحضير",
    "fr": "Préparation",
    "de": "Vorbereitung",
    "es": "Preparación",
    "ru": "Подготовка",
    "zh": "准备",
    "ja": "準備",
    "ko": "준비",
    "hi": "तैयारी"
  },
  "tagSenior": {
    "id": "Lansia",
    "en": "Elderly",
    "ar": "كبار السن",
    "fr": "Personnes âgées",
    "de": "Senioren",
    "es": "Adultos mayores",
    "ru": "Пожилые",
    "zh": "老年人",
    "ja": "高齢者",
    "ko": "노인",
    "hi": "वरिष्ठ नागरिक"
  },
  "tagMedical": {
    "id": "Medis",
    "en": "Medical",
    "ar": "طبي",
    "fr": "Médical",
    "de": "Medizinisch",
    "es": "Médico",
    "ru": "Медицинский",
    "zh": "医疗",
    "ja": "医療",
    "ko": "의료",
    "hi": "चिकित्सा"
  },
  "source": {
    "id": "Rangkuman anjuran kesehatan jamaah (Kemenkes RI & WHO) dan adab makan dalam sunnah. Konsultasikan kondisi khusus dengan dokter.",
    "en": "A summary of health recommendations for pilgrims (Indonesian Ministry of Health & WHO) and eating etiquette from the Sunnah. Consult a doctor for special conditions.",
    "ar": "ملخص التوصيات الصحية للحجاج والمعتمرين (وزارة الصحة الإندونيسية ومنظمة الصحة العالمية) وآداب الطعام في السنة النبوية. استشر الطبيب في الحالات الخاصة.",
    "fr": "Un résumé des recommandations sanitaires pour les pèlerins (Ministère de la Santé indonésien & OMS) et des règles de bienséance alimentaire issues de la Sunnah. Consultez un médecin pour les cas particuliers.",
    "de": "Eine Zusammenfassung der Gesundheitsempfehlungen für Pilger (Indonesisches Gesundheitsministerium & WHO) und der Speiseetikette aus der Sunnah. Konsultieren Sie bei besonderen Zuständen einen Arzt.",
    "es": "Un resumen de las recomendaciones de salud para peregrinos (Ministerio de Salud de Indonesia & OMS) y las normas de etiqueta alimentaria de la Sunnah. Consulte a un médico para condiciones especiales.",
    "ru": "Краткое изложение рекомендаций по здоровью для паломников (Министерство здравоохранения Индонезии и ВОЗ) и этикета питания из Сунны. Проконсультируйтесь с врачом по особым случаям.",
    "zh": "朝觐者健康建议摘要（印度尼西亚卫生部及世卫组织）及圣行中的饮食礼仪。特殊情况请咨询医生。",
    "ja": "巡礼者への健康推奨事項の要約（インドネシア保健省・WHO）とスンナにおける食事作法。特別な状態については医師にご相談ください。",
    "ko": "순례자를 위한 건강 권고 사항 요약(인도네시아 보건부 및 WHO)과 순나의 식사 예절. 특별한 상태는 의사와 상담하십시오.",
    "hi": "हाजियों के लिए स्वास्थ्य अनुशंसाओं का सारांश (इंडोनेशिया स्वास्थ्य मंत्रालय और WHO) तथा सुन्नह में खाने के आदाब। विशेष परिस्थितियों में चिकित्सक से परामर्श करें।"
  }
};
